<template>
  <div class="filters-container">
    <ul class="filters" ref="dfilters">
      <div class="filters__filter__activator"
           :style="{'left': left, 'width': width }">
      </div>
      <li v-for="(filter, idx) in filters"
          @click="setFilter(filter)"
          :id="'filter_' + filter.value"
          class="filters__filter"
          :class="{'filters__filter--active': isFilter(filter.value)}">
        {{ filter.label }}
        <span class="filter__length">({{ filter.length }})</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DFilters',
  props: {
    initialFilter: {
      default: ''
    },
    filters: {
      type: Array,
      default: () => [
        {label: 'Alle', value: '', length: 20},
        {label: 'Undervisning', value: 'person_resource', length: 10},
        {label: 'Øvrige opgaver', value: 'additional_tasks', length: 8},
        {label: 'Forberedelse', value: 'preparation', length: 2}
      ]
    }
  },
  data () {
    return {
      left: 0,
      width: 0
    }
  },
  watch: {
    initialFilter () {
      this.selectorSliderLeft()
    }
  },
  methods: {
    setFilter (filter) {
      this.$emit('set', filter.value)
    },
    isFilter (filterValue) {
      return this.initialFilter === filterValue
    },
    selectorSliderLeft () {
      let el = document.querySelector('#filter_' + this.initialFilter)
      if (!el) {
        return
      }
      let parentBCR = this.$refs.dfilters.getBoundingClientRect()
      let BCR = el.getBoundingClientRect()
      this.width = BCR.width + 'px'
      this.left = ((BCR.left * 1) - (parentBCR.left * 1)) + 'px'
    }
  },
  mounted () {
    // Wait for animations to be done
    setTimeout(_ => {
      this.selectorSliderLeft()
    }, 500)
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.filters-container {
  position: relative;
  width: 100%;
}

.filters {
  position: relative;
  display: flex;
  font-size: 0.85rem;
  text-transform: uppercase;
  color: var(--grey);
  font-weight: bold;
  margin: 0;
}

.filters__filter {
  position: relative;
  cursor: pointer;
  user-select: none;
  padding: 1rem 0;
  z-index: 2;
  transition: color 0.25s;
  margin-right: 2rem;
}

.filters__filter:hover {
  color: var(--dark-blue);
}

.filters__filter--active {
  color: var(--dark-blue);
}

.filters__filter__activator {
  position: absolute;
  bottom: 1px;
  left: 0;
  background: var(--blue);
  height: 2px;
  width: 25%;
  z-index: 2;
  border-radius: 4px;
  transition: all 0.3s;
}

</style>



// WEBPACK FOOTER //
// DFilters.vue?14104d92